import { css } from "./SKT";

export const SKTTableRow = ({ label, children }) => {
  return (
    <tr>
      <th>{label}</th>
      <td>{children}</td>
    </tr>
  );
};

export const SKTTable = ({ children }) => {
  return <table className={css("table table-striped")}>{children}</table>;
};

export const SKTTableBody = ({ children }) => {
  return <tbody>{children}</tbody>;
};

export const SKTTableHeader = ({ children }) => {
  return <thead>{children}</thead>;
};
